// extracted by mini-css-extract-plugin
export default {"pureTree":"pure-tree_pureTree__ZE8U3"};